
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';


function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);



    
          useEffect(() => {
                menus.map((item) => {
                    if (item.id === 479) {
                        setdrinks(item);
                    }
                });
          }, [menus]);
        
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={() => {
            setdishs(drinks)
            setShowListProduct(true)
        }}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                        {menus.map((item, key) => {
                            return (
                                <div
                                    key={key}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 335,
                                        position: 'relative',
                                        cursor: 'pointer',
                                        overflow: 'hidden',
                                        borderRadius: 20,
                                        marginBottom: 10
                                    }}
                                    onClick={() => { 
                                      
                                        setShowListProduct(true);
                                        setdishs(item);
                                    }}
                                >
                                    {/* Imagen de fondo */}
                                    <img
                                        src={`https://tumenu.online/images/categories/icons/${item.icon}`}
                                        style={{
                                           
                                            width: '100%',
                                            height: 195,
                                            objectFit: 'cover',
                                            borderRadius: 20,
                                            transition: 'transform 0.3s ease-in-out'
                                        }}
                                    />

                                    {/* Overlay con efecto hover */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                            opacity: 1,
                                            transition: 'opacity 0.3s ease-in-out'
                                        }}
                                        className="overlay"
                                    ></div>

                                    <p
                                        className="text-shadow"
                                        style={{
                                            position: 'absolute',
                                            fontFamily: 'Inter',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            fontSize: 35,
                                            transition: 'transform 0.3s ease-in-out'
                                        }}
                                    >
                                        {item.name}
                                    </p>

                                   
                                </div>
                            );
                        })}

                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={ setshowCategories} />}
            </LayoutContent>
        </div>
    );
}
export default Index;